import React, { useState } from 'react';
import axios from 'axios';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const res = await axios.post('/api/contact', formData);
      setStatus('success');
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

  return (
    <section className="section light" id="contact">
      <h2 className="section-title">Contact Us</h2>
      <p className="section-subtitle">
        Have questions or need a demo? Fill out the form below and our team will
        get back to you shortly.
      </p>
      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name *"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email *"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="phone"
          placeholder="Phone (optional)"
          value={formData.phone}
          onChange={handleChange}
        />
        <textarea
          name="message"
          placeholder="Your Message *"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
        <button type="submit" className="btn btn-primary" disabled={status === 'loading'}>
          {status === 'loading' ? 'Sending…' : 'Send Message'}
        </button>
      </form>
      {status === 'success' && (
        <p style={{ color: 'green', textAlign: 'center', marginTop: '1rem' }}>
          Thank you! Your message has been sent.
        </p>
      )}
      {status === 'error' && (
        <p style={{ color: 'red', textAlign: 'center', marginTop: '1rem' }}>
          Sorry, there was a problem sending your message. Please try again later.
        </p>
      )}
      <div className="contact-info">
        <p>Micro 24 Energy</p>
        <p>282, Vision 9, Pimple Saudagar, Pune, Maharashtra – 411027</p>
        <p>
          <a href="tel:+918530660909">+91 85306 60909</a>
        </p>
        <p>
          <a href="mailto:sales@micro24.com">sales@micro24.com</a> |{' '}
          <a href="mailto:support@micro24.com">support@micro24.com</a>
        </p>
      </div>
    </section>
  );
};

export default ContactSection;